import { createFileRoute } from "@tanstack/react-router"
import { BudgetsTab } from "./_budgets-tab"

export const Route = createFileRoute("/settings/budgets")({
  component: BudgetsTab,
})
